<template>
	<div class='badge'>
		<img class='badge-img' :src='badge().ImageUrl'><br/>
		<a class='badge-terms' target='_blank' :href='badge().TermsOfServiceUrl'>
			Terms of Service
		</a>
	</div>
</template>

<script>

import { mapGetters } from "vuex";

export default {
	name: "Badge",
	methods: {
		...mapGetters(["badge"])
	}
}
</script>
